import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
const sizeToPx = {
    small: 20,
    medium: 24,
};
export const StyledButton = styled.button `
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $size }) => pxToRem(sizeToPx[$size])};
  height: ${({ $size }) => pxToRem(sizeToPx[$size])};
  background-color: ${({ $selected }) => ($selected ? themeGet('colors.primary.1000') : themeGet('colors.primary.0'))};
  border: ${pxToRem(1)} solid
    ${({ $selected }) => ($selected ? themeGet('colors.border.300') : themeGet('colors.border.200'))};
  border-radius: ${themeGet('borderRadius.circle')};
  outline: ${pxToRem(0)} solid transparent;
  transition: outline 0.1s ease-in-out;

  &:focus-visible {
    box-shadow: 0 0 0 ${pxToRem(4)} ${themeGet('colors.focus.primary')};
  }

  &:hover:not(:disabled) {
    background-color: ${({ $selected }) => $selected ? themeGet('colors.primary.800') : themeGet('colors.primary.200')};
  }

  &:active:not(:disabled) {
    outline: ${pxToRem(2)} solid ${themeGet('colors.primary.100')};
  }

  &:disabled {
    opacity: 0.5;
  }
`;
